import Image from 'next/image';
import Script from 'next/script';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PardotAnalyicsBase from './analytics/pardot-analytics-base';

const Footer = () => {
  const router = useRouter();
  return (
    <>
      <footer id="site-footer" className="footer mt-auto">
        <div className="container-xl">
          <div className="row">
            <div className="col-md-4 pb-3 pb-md-0">
              <Link href="/" passHref>
                <a>
                  <Image
                    height={80}
                    src="/images/logo-white.png"
                    width={200}
                    alt="College Recruiter"
                    priority
                  />
                </a>
              </Link>

              <p>
                College Recruiter believes every student and recent grad deserves a great career.
              </p>
            </div>
            <div className="col-md-8">
              <div className="row">
                <div className="col-sm-4 pb-3">
                  <p className="heading">College Recruiter</p>
                  <div className="link-list">
                    <Link passHref href="/about">
                      About
                    </Link>
                    <Link passHref href="/team">
                      Team
                    </Link>
                    <Link passHref href="/success-stories">
                      Success Stories
                    </Link>
                    <Link passHref href="/contact">
                      Contact
                    </Link>
                  </div>
                </div>
                <div className="col-sm-4 pb-3">
                  <p className="heading">For Job Seekers</p>
                  <div className="link-list">
                    <Link passHref href="/job-search">
                      Find Jobs
                    </Link>
                    <Link passHref href="/blog/category/career-advice-for-job-seekers">
                      Articles
                    </Link>
                    <Link passHref href="/videos">
                      Videos
                    </Link>
                  </div>
                </div>
                <div className="col-sm-4 pb-3">
                  <p className="heading">For Employers</p>
                  <div className="link-list">
                    <Link passHref href="/employers">
                      Advertising Solutions
                    </Link>
                    <Link passHref href="/publisher-partnership-program">
                      Publisher Program
                    </Link>
                    <Link passHref href="/blog/category/advice-for-employers-and-recruiters">
                      Articles
                    </Link>
                    <Link passHref href="/videos">
                      Videos
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 pb-3">
              <div className="socials">
                <Link passHref href="https://www.facebook.com/EntryLevelJobs">
                  <a className="fa-brands fa-facebook" target="_blank">
                    <span className="sr-only">Facebook</span>
                  </a>
                </Link>
                <Link passHref href="https://twitter.com/entryleveljob">
                  <a className="fa-brands fa-twitter" target="_blank">
                    <span className="sr-only">Twitter</span>
                  </a>
                </Link>
                <Link passHref href="https://www.linkedin.com/company/collegerecruiter-com">
                  <a className="fa-brands fa-linkedin" target="_blank">
                    <span className="sr-only">LinkedIn</span>
                  </a>
                </Link>
                <Link
                  passHref
                  href="https://www.youtube.com/user/collegerecruiter?sub_confirmation=1"
                >
                  <a className="fa-brands fa-youtube" target="_blank">
                    <span className="sr-only">YouTube</span>
                  </a>
                </Link>
              </div>
            </div>
            <div className="col-sm-8">
              <p className="legal">
                Copyright &copy; 2022 College Recruiter, Inc. |{' '}
                <Link passHref href="/privacy">
                  Privacy Policy
                </Link>{' '}
                |{' '}
                <Link passHref href="/terms-of-use">
                  Terms of Use
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>

      <Script id="ga-params" type="text/javascript">
        {`
        var google_conversion_id = 863683834;
        var google_custom_params = window.google_tag_params;
        var google_remarketing_only = true;
       `}
      </Script>
      <Script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></Script>

      <noscript>
        <div>
          <Image
            height={1}
            width={1}
            alt=""
            src="https://googleads.g.doubleclick.net/pagead/viewthroughconversion/863683834/?guid=ON&amp;script=0"
          />
        </div>
      </noscript>

      {!router.pathname.match(/job-search/) && !router.pathname.match('/job') ? (
        <PardotAnalyicsBase />
      ) : (
        ''
      )}
    </>
  );
};

export default Footer;
